// Ponto de entrada da aplicacao React
// Fontes Geist carregadas via @font-face em globals.css (geist pkg nao tem entry nao-Next.js)
import "@/styles/globals.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
